<template>
    <div >
     <MediaLibraryCategoryTracksList :client_name="client_name"
      :media_library="media_library"
    :card_title_class="'card-title-irish-date'" 
    :display_tabs="false"
                  :project_btn_class="'btn-mid'"
    
    :search_input_class="'input-group-search-mid'"
                  :input_class="'form-control-mid'"
                  :btn_size_class="'btn-lg-mid'" 
                  :btn_variant_primary="'mid-primary'"
    
                :modal_class="'modal-irish-date'"
                :btn_submit_class="'btn-mid btn-mid-submit'"
              
                :form_label_class="'form-label-mid'"   
                :error_validation_msg_class="'error_validation_message_p_mid'"
                :video_preview_container_class="'video-preview-container-irish-date'"
                :add_video_btn_outline_variant="'mid-primary-outline'"
                :progress_bar_class="'progress-bar-irish-date'"
                :vselect_class="'form-group-vselect-mid'"
                
                :media_category_title_class="'media-category-title-irish-date'"
                :player_container_class="'player-container-mid'"
                :current_player_title_class="'current-player-title-mid'"
                :current_player_description_class="'current-player-description-mid'"
                
              
                :dropdown_action_class="'dropdown-actions-mid'"
                :playlist_tracks_class="'playlist-tracks-mid'"
                :dataset_data_info_class="'datasetInfoMID'"
                  :dataset_pagination_class="'datasetPagerMID'"
                :playlist_item_class="'playlist-item-mid'"
                :confirm_message_class="'message-modal-mid'"
                :btn_danger_outline_class="'mid-danger-outline'"
                
    
                :swal_confirm_button_class="'btn btn-bumblebee btn-mid  btn-mid-primary'"
            :swal_container_class="'swal-container-mid'"
    
    />
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import $ from "jquery";
  
  import MediaLibraryCategoryTracksList from '@/components/media_components/library/CategoryTracksList.vue'
  
  export default {
    name: "MIDVideoLibraryCategoryVideos",
    components: { MediaLibraryCategoryTracksList },
    data() {
      return {
        client_name: "MID",
        media_library: "video_library",
    
      };
    },
    mounted() {
    },
    computed: {},
    created() {
    },
    methods: {  },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/my_irish_date/video_library/CategoryTracksList.vue